import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DropdownArrow from '../../../../icons/icon-arrow-down.svg';
import CommodityIcon from '../../../CommodityIcon/CommodityIcon';
import getCommodityValue from '../../../../helpers/getCommodityValue';


export default function AttributeLink({ locationDisplay, allowSelection }) {
  const attributeLinkClass = classNames({
    'attribute-selector__modal-link': allowSelection,
    'attribute-selector__modal-link--disabled': !allowSelection,
  });
  const role = allowSelection ? 'button' : 'none';
  const tabIndex = allowSelection ? '0' : false;

  const commodityValue = getCommodityValue();

  const attributeIconClass = classNames('attribute-selector-link__commodity-icon', {
    'attribute-selector-link__commodity-icon--combined': commodityValue === 'combined',
    'attribute-selector-link__commodity-icon--single': commodityValue !== 'combined',
  });

  return (
    <div
      role={role}
      tabIndex={tabIndex}
      className={attributeLinkClass}
    >
      <div className="attribute-selector-link">
        <CommodityIcon className={attributeIconClass} commodityValue={commodityValue} />
        <div className="attribute-selector-link__location-container">
          <div className="attribute-selector-link__shopping">Service type:</div>
          <div className="attribute-selector-link__location">
            {locationDisplay}
            &nbsp;
            {allowSelection && (
              <span className="attribute-selector-link__dropdown-icon">
                <DropdownArrow />
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

AttributeLink.propTypes = {
  locationDisplay: PropTypes.string.isRequired,
  allowSelection: PropTypes.bool.isRequired,
};
